export default "__VITE_ASSET__BUlTjYwz__"